// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GiftsStore_wrap__2rPpd","gifts":"GiftsStore_gifts__2ScNs"};